/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlResolutionRequestResponse } from './ControlResolutionRequestResponse';
import {
    ControlResolutionRequestResponseFromJSON,
    ControlResolutionRequestResponseFromJSONTyped,
    ControlResolutionRequestResponseToJSON,
} from './ControlResolutionRequestResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedResolutionsResponse
 */
export interface ControlPaginatedResolutionsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedResolutionsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedResolutionsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedResolutionsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlResolutionRequestResponse>}
     * @memberof ControlPaginatedResolutionsResponse
     */
    results: Array<ControlResolutionRequestResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedResolutionsResponse interface.
 */
export function instanceOfControlPaginatedResolutionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedResolutionsResponseFromJSON(json: any): ControlPaginatedResolutionsResponse {
    return ControlPaginatedResolutionsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedResolutionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedResolutionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlResolutionRequestResponseFromJSON)),
    };
}

export function ControlPaginatedResolutionsResponseToJSON(value?: ControlPaginatedResolutionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlResolutionRequestResponseToJSON)),
    };
}

